export default __webpack_public_path__ + "static/social-infographics-5171bfe5b3c37a8c936eee9f30d43cd9.png";